import { useState, useEffect } from "react";
import TimeInput from "../../components/TimeInput/TimeInput";
import TextSkeleton from "../../components/SkeletonComponents/TextSkeleton";

const RestRangeInput = (props) => {
  const [currentRest, setCurrentRest] = useState({
    min: {
      ...(props.rest && props.rest.min ? props.rest.min : {}),
    },
    max: {
      ...(props.rest && props.rest.max ? props.rest.max : {}),
    },
  });
  const isLoading = props.isLoading;

  useEffect(() => {
    setCurrentRest({
      min: {
        ...(props.rest && props.rest.min ? props.rest.min : {}),
      },
      max: {
        ...(props.rest && props.rest.max ? props.rest.max : {}),
      },
    });
  }, [props.rest]);

  const handleMinimumRestSubmit = (newMinimumRest) => {
    props.onSubmit({ min: newMinimumRest, max: currentRest.max });
  };

  const handleMaximumRestSubmit = (newMaximumRest) => {
    props.onSubmit({ min: currentRest.min, max: newMaximumRest });
  };

  return (
    <>
      <h2 className="block text-sm font-medium text-gray-700">Rest Range</h2>
      <div className="grid grid-cols-[auto,auto,auto] w-min items-center max-[326px]:grid-cols-[1fr]">
        <TimeInput
          id="rest-range-min"
          initialMinutesValue={currentRest.min.minutes || ""}
          initialSecondsValue={currentRest.min.seconds || ""}
          onBlur={handleMinimumRestSubmit}
          isLoading={isLoading}
        />
        <span className="block text-sm text-gray-700 px-4 max-[326px]:text-center max-[326px]:mb-3">
          to
        </span>
        <TimeInput
          id="rest-range-max"
          initialMinutesValue={currentRest.max.minutes || ""}
          initialSecondsValue={currentRest.max.seconds || ""}
          onBlur={handleMaximumRestSubmit}
          isLoading={isLoading}
        />
        <span className="pl-0.5 block text-xs text-gray-700 pt-1 max-[326px]:row-[2]">
          Min
        </span>
        <span className="pl-0.5 block text-xs text-gray-700 pt-1 col-[3_/_span_1] max-[326px]:col-[1_/_span_1]">
          Max
        </span>
      </div>
    </>
  );
};

export default RestRangeInput;
